/**
 * Growing Grid JavaScript
 *
 * This file defines behaviors of
 * the Growing Grid block.
 */

jQuery(($) => {
	const growGrid = {
		// first run
		init() {
			// for each grid
			const $grows = $('.js-grow');
			$('.js-grow').each((i) => {
				// cache things
				const $grow = $grows.eq(i);
				const $pieces = $grow.find('.js-grow-piece');

				// kick things off
				this.bindIso($pieces, $grow);
				this.pubExpand($pieces);
				this.pubClose($pieces);
				this.subExpand($pieces, $grow);
				this.subClose($pieces, $grow);
				this.bindLoad($pieces);
				this.bindHashChange($pieces);
			});
		},

		// apply isotope
		bindIso($pieces, $grow) {
			// set up standard options
			const attr = {
				percentPosition: true,
				itemSelector: '.js-grow-piece',
				stagger: 50,
				masonry: {
					columnWidth: '.js-grow-sizer',
				},
			};
			// set up optional sort options
			if ($grow.data('sort')) {
				attr.getSortData = {
					order: '[data-cur-order]',
				};
			}
			// apply isotope
			$grow
				.isotope(attr)
				// have the items sweep in initially from hidden
				.isotope('revealItemElements', $pieces.addClass('ready'));
		},

		// publish load event
		bindLoad() {
			// check for a hash in the url
			const hashSet = window.location.hash;
			if (hashSet) {
				// try to click it (simply doesn't trigger if it doesn't exist)
				$(hashSet).trigger('expand.growGrid');
			}
		},

		// publish expand event if click on applicable anchor tag
		bindHashChange() {
			// keep updating the page when users transition to a new hash
			window.onhashchange = function () {
				// check for a hash in the url and activate its item
				const hashSet = window.location.hash;
				$(hashSet).trigger('expand.growGrid');
			};
		},

		// publish expand event on click
		pubExpand($el) {
			$el.on('click.growGrid', function () {
				const $this = $(this);
				// activate this item if not already activated
				if (!$this.hasClass('active')) {
					$(this).trigger('expand.growGrid');
				}
			});
		},

		// subscribe to expand events
		subExpand($el, $iso) {
			$el.on('expand.growGrid', function () {
				const $this = $(this);

				// set url hash to match this item
				history.pushState(null, null, `#${$this.attr('id')}`);

				// turn off any expanded pieces
				let didClose = false;
				$el.not($this).each(function () {
					const $this = $(this);
					// if something's expanded remove expansion and note that it occurred
					if ($this.hasClass('grow-grid__item--expanded')) {
						didClose = true;
						$this.trigger('close.growGrid');
						// reflow after closing things
						growGrid.reflow($iso);
					}
					// change order back to original value if necessary
					if ($iso.data('sort')) {
						$this.attr('data-cur-order', $this.attr('data-order'));
					}
				});

				// wait a bit for things to close if they're closing
				const timer = $iso.data('sort') && didClose ? 1000 : 0;

				// smooth in the transition
				growGrid.tempClass(
					$this,
					'grow-grid__item--is-expanding',
					600,
					timer
				);

				// start sorting (so we bubble active item to correct position)
				growGrid.resort($this, $el);
				// wait for smooth fadeout
				setTimeout(() => {
					// wait for things to close to activate or activate immediately depending on timer
					setTimeout(() => {
						// reorder if appropriate (now that potentially things are closed/resized)
						if ($iso.data('sort')) {
							$el.each(function () {
								const $thisOne = $(this);
								$thisOne.attr(
									'data-cur-order',
									$thisOne.attr('data-order')
								);
							});
							growGrid.resort($this, $el);
						}
						// expand this one
						$this.addClass('grow-grid__item--expanded active');
						// now reflow with the new size in place
						growGrid.reflow($iso, $this);
					}, timer);
				}, 300);
			});
			/* prettier-ignore */
			// setTimeout(()=> { $el.eq(3).trigger('click'); }, 1000); /* DEBUG */
		},

		// publish to close button clicks
		pubClose($el) {
			$el.each(function () {
				const $this = $(this);
				$this.find('.js-grow-grid-close').on('click.growGrid', (e) => {
					if ($this.hasClass('active')) {
						e.stopPropagation();
						history.pushState(
							'',
							document.title,
							window.location.pathname
						);
						$this.trigger('close.growGrid');
					}
				});
			});
		},

		// subscribe to close events
		subClose($el, $iso) {
			$el.on('close.growGrid', function () {
				const $this = $(this);

				// smooth in the transition
				growGrid.tempClass($this, 'grow-grid__item--is-closing');

				// wait for smooth fadeout
				setTimeout(() => {
					// turn off this expanded pieces
					$this.removeClass('grow-grid__item--expanded active');
					// change order if necessary
					if ($iso.data('sort')) {
						$this.attr('data-cur-order', $this.attr('data-order'));
					}
				}, 300);

				growGrid.reflow($iso);
			});
		},

		// reflow the tiles
		reflow($iso, $activeEl) {
			// call reflow after some stuff starts shifting so there's movement
			let timer = 10;
			setTimeout(() => {
				$iso.isotope('layout');
			}, timer);
			// reorder items first if needed (active item bubbles to top) or skip without adding delay
			timer += 300;
			if ($iso.data('sort')) {
				setTimeout(() => {
					$iso.isotope('layout')
						.isotope('reloadItems')
						.isotope({ sortBy: 'order' });
				}, timer - 10); // stacks animations a bit (remove -10 for no animation overlap)
				timer += 750;
			}

			// call reflow again after all animation has completed
			setTimeout(() => {
				$iso.isotope('layout');
				// scroll to the active item
				if ($activeEl) {
					$activeEl.get(0).scrollIntoView({
						behavior: 'smooth',
						block: 'end',
					});
				}
			}, timer);
		},

		// re-sort order of elements
		resort($thisEl, $el) {
			// get the top of this dom element
			const thisTop = Math.round($thisEl.offset().top);
			// determine the index of this item amongst all the others
			let curItem = $el.index($thisEl);
			// set current top to the top of this item
			let curTop = thisTop;
			// store the current element itself
			let $curEl = null;

			while (thisTop === curTop) {
				// get this item
				$curEl = $el.eq(curItem);
				// set the top of this item
				curTop = Math.round($curEl.offset().top);
				// exit if this is in a different row
				if (thisTop !== curTop) {
					break;
					// exit if we've reached the very first item in the first row
				} else if (curItem === 0) {
					curItem = -1;
					break;
					// get ready to look at the previous item
				} else {
					curItem--;
				}
			}

			// restort to top
			$thisEl.attr('data-cur-order', 0);
		},

		// temporarily add a class
		tempClass($el, className, wait, start) {
			// establish defaults
			const waitTime = wait || 600;
			const startTime = start || 0;

			// add the class
			setTimeout(() => {
				$el.addClass(className);
			}, startTime);
			// remove the class
			setTimeout(() => {
				$el.removeClass(className);
			}, startTime + waitTime);
		},
	};

	growGrid.init();
});
